import { render, staticRenderFns } from "./RecordImage.vue?vue&type=template&id=5c3fef92&"
import script from "./RecordImage.vue?vue&type=script&lang=js&"
export * from "./RecordImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports